// constants.ts
import { version } from './version';
export const DEFAULT_HEADERS = { 'X-Client-Info': `supabase-js/${version}` };
//# sourceMappingURL=constants.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@supabase/supabase-js/dist/module/lib/constants.js
// module id = null
// module chunks = 